// /Users/ammadtarar/Documents/Repo/TMA/tma-fe/src/api/sitesApi.ts
import api from "./client";

import type { ApiResponse, BaseFilterParams, Paginated } from "#/types/api";
import type { CreateSitePayload, Site } from "#/types/sites";
import type { Ticket } from "#/types/tickets";

export const sitesApi = {
  create: (body: CreateSitePayload): Promise<ApiResponse<Site>> =>
    api.post("/site", body),
  update: (
    id: number,
    body: Partial<CreateSitePayload>
  ): Promise<ApiResponse<Ticket>> => api.patch(`/site/${id}`, body),
  getAll: (params: BaseFilterParams): Promise<ApiResponse<Paginated<Site[]>>> =>
    api.get("/site", { params }),
  getById: (id: number): Promise<ApiResponse<Site>> => api.get(`site/${id}`),
};
